import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import { Link as RouterLink } from "react-router-dom";
/**
 * Reusable sidebar nav item.
 * - Uses MUI + React Router Link
 * - Handles collapsed tooltips
 */
function NavItem({ to, icon: Icon, label, isActive, isCollapsed, onClick, }) {
    const handleClick = (e) => {
        // Prevent default navigation if onClick is provided
        if (onClick) {
            onClick(e);
        }
        // RouterLink will handle navigation, no need to prevent default
    };
    const button = (_jsxs(ListItemButton, { component: RouterLink, to: to || '#', onClick: handleClick, selected: isActive, sx: {
            borderRadius: 1,
            mx: 1,
            my: 0.25,
            "&.Mui-selected": {
                bgcolor: "#FFFAFD",
                border: "1px solid #FF008E",
                "&:hover": { bgcolor: "#FFFAFD" },
            },
        }, children: [_jsx(ListItemIcon, { sx: { minWidth: 36, color: isActive ? "#FF008E" : "text.main" }, children: _jsx(Icon, { fontSize: "small" }) }), !isCollapsed && (_jsx(ListItemText, { primary: label, primaryTypographyProps: {
                    variant: "body2",
                    sx: { fontWeight: isActive ? 600 : 500, color: isActive ? "#FF008E" : "text.main" },
                } }))] }));
    if (!isCollapsed)
        return button;
    return (_jsx(Tooltip, { title: label, placement: "right", children: button }));
}
export default memo(NavItem);
